import { SectionContainer, Typography } from 'ui';

import { MultiLoadAutoComplete } from '~/load/components/MultiLoadAutoComplete/MultiLoadAutoComplete';

type LoadsSectionProps = {
  hasShipment?: boolean;
  shipmentName?: string;
  salesOrderSlug?: string;
};

export const LoadsSection = ({ hasShipment, salesOrderSlug, shipmentName }: LoadsSectionProps) => {
  return (
    <SectionContainer title="Select Loads" columns={1}>
      <MultiLoadAutoComplete
        label="Loads"
        name="load_ids"
        assignableToShipment={shipmentName}
        hasShipment={hasShipment}
        salesOrderSlug={salesOrderSlug}
      />
      <Typography>
        Only loads without a shipment will be shown. You can create an empty shipment and add loads later.
      </Typography>
    </SectionContainer>
  );
};
